var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app2"}},[_c('h3',{staticClass:"subtitle",staticStyle:{"color":"white","padding":"5%"}},[_vm._v(_vm._s(_vm.selected))]),_c('canvas',{attrs:{"id":"line-chart"}})])}
var staticRenderFns = []

export { render, staticRenderFns }